// Mirror of back/helpers/postDeletable.js for the UI. Lets the kanban
// menu / list row / preview hide the Delete option for posts that have
// already gone out on a platform — same rule the server enforces, so
// the user never sees an action that'd be rejected with a 409.
//
// See the backend helper's header for the rationale (deleting the local
// row doesn't unpublish on LinkedIn/Facebook/Pinterest, just hides the
// audit trail).

export const POSTED_STATUSES = new Set(['posted', 'partially-posted']);

export function isPosted(post) {
  if (!post) return false;
  if (POSTED_STATUSES.has(String(post.queueStatus || ''))) return true;
  if (post.postPostedDate) return true;
  return false;
}

// Convenience inverse used by menu items / icon buttons.
export function canDeletePost(post) {
  return !isPosted(post);
}
